import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Routes, RouterModule} from '@angular/router';

import {LegalNoticeComponent} from "./legal-notice.component";
import {PrivacyComponent} from "./privacy/privacy.component";


const routes: Routes = [
  {
    path: 'legal-notice',
    component: LegalNoticeComponent,
  },
  {
    path: 'privacy',
    component: PrivacyComponent,
  }
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
})
export class LegalNoticeRoutingModule {
}
